<template>
  <div class="cmp-content-block">
    <div class="title">{{ title }}</div>
    <div class="content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "CmpContentBlock",
  props: {
    title: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/assets/scss/_variables.scss";
.cmp-content-block {
  margin-bottom: 24px;
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
  min-height: 1px;
  padding: 1.25rem;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 0 solid #f6f6f6;
  border-radius: 0.25rem;

  > .title {
    font-size: 18px;
    margin: 0 0 20px 0;
    font-weight: 400;
    color: $mp-color-text-highlight;
  }

}
</style>
